module.exports = __webpack_public_path__ + "static/marcin-skalij-nXGw951o3Hk-unsplash_modified-54b7247e38754cb9d6eefce74795e600.jpg";